export const API_URL = 'http://localhost:4000/api';
export const DATE_FORMAT = 'DD.MM.YYYY';

export const DATEPICKER_LOCALE: any = {
	lang: {
		locale: 'en_US',
		placeholder: 'Vali kuupäev',
		rangePlaceholder: ['Algus kuupäev', 'Lõpp kuupäev'],
		today: 'Täna',
		now: 'Praegu',
		backToToday: 'Tagasi tänasele',
		ok: 'Ok',
		clear: 'Puhasta',
		month: 'Kuu',
		year: 'Aasta',
		timeSelect: 'Vali aeg',
		dateSelect: 'Vali kuupäev',
		monthSelect: 'Vali kuu',
		yearSelect: 'Vali aasta',
		decadeSelect: 'Vali kümnend',
		yearFormat: 'YYYY',
		dateFormat: DATE_FORMAT,
		dayFormat: 'D',
		dateTimeFormat: 'DD.MM.YYYY HH:mm:ss',
		monthFormat: 'MMMM',
		monthBeforeYear: true,
		previousMonth: 'Eelmine kuu',
		nextMonth: 'Järgmine kuu',
		previousYear: 'Eelmine aasta',
		nextYear: 'Järgmine aasta',
		previousDecade: 'Viimane kümnend',
		nextDecade: 'Järgmine kümnend',
		previousCentury: 'Viimane sajand',
		nextCentury: 'järgmine sajand',
	},
	timePickerLocale: {
		placeholder: 'Vali aeg',
	},
	dateFormat: DATE_FORMAT,
	dateTimeFormat: 'DD.MM.YYYY HH:mm:ss',
	weekFormat: 'YYYY-wo',
	monthFormat: 'YYYY-MM',
};

export const MAINTENANCE_CHECK_FIELDS_DATA = [
	{
		key: 'hours',
		name: 'Hours',
	},
	{
		key: 'cycles',
		name: 'Cycles',
	},
	{
		key: 'landings',
		name: 'Landings',
	},
];

export const BILLING_CURRENCIES = [
	{
		value: 'eur',
		symbol: '€',
	},
	{
		value: 'usd',
		symbol: '$',
	},
];

export const AIRCRAFT_TYPES = {
	no_engine: 'No Engine',
	piston: 'Piston',
	turbine: 'Single Turbine',
	twin_turbine: 'Twin Turbine',
	jet: 'Jet',
};
